import React from 'react'
import { useOutletContext } from 'react-router-dom'
import type { HistoryOutletContext } from './ModernHistoryLayout'
import HistoryWalletReport from './HistoryWalletReport'

/** หน้า ประวัติการฝากเงิน */
const HistoryDepositPage: React.FC = () => {
  useOutletContext<HistoryOutletContext>()
  return <HistoryWalletReport mode="deposit" />
}

export default HistoryDepositPage
